/** Station marker style on map route polylines. */
export enum StationMarkerVariantEnum {
  pin = "pin",
  dot = "dot",
  waypoint = "waypoint",
}
